/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free lump-sum investment calculator. Enter a one-time investment, expected return and period to estimate its future value and gains.`)
};

const es_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de inversión de suma única gratuita. Ingresa una inversión única, retorno esperado y período para estimar su valor futuro y ganancias.`)
};

const de_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Pauschalanlage-Rechner. Geben Sie eine einmalige Investition, erwartete Rendite und Zeitraum ein, um den zukünftigen Wert und Gewinne zu schätzen.`)
};

const nl_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis eenmalige beleggingscalculator. Voer een eenmalige belegging, verwacht rendement en periode in om de toekomstige waarde en winsten in te schatten.`)
};

const fr_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'investissement versement unique gratuite. Entrez un investissement unique, le rendement attendu et la période pour estimer sa valeur future et ses gains.`)
};

const it_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di investimento forfettario gratuito. Inserisci un investimento una tantum, il rendimento atteso e il periodo per stimare il valore futuro e i guadagni.`)
};

const pt_br2_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de investimento único gratuita. Digite um investimento único, retorno esperado e período para estimar seu valor futuro e ganhos.`)
};

const pt_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de investimento em montante único gratuita. Introduza um investimento único, retorno esperado e período para estimar o seu valor futuro e ganhos.`)
};

const ja_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の一括投資計算機。ワンタイムの投資額、期待利回り、期間を入力して、将来価値と利益を推定します。`)
};

const zh_sip_lumpsum_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费一次性投资计算器。输入一次性投资、预期收益率和期限，估算其未来价值和收益。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_meta_description", locale)
	if (locale === "en") return en_sip_lumpsum_meta_description(inputs)
	if (locale === "es") return es_sip_lumpsum_meta_description(inputs)
	if (locale === "de") return de_sip_lumpsum_meta_description(inputs)
	if (locale === "nl") return nl_sip_lumpsum_meta_description(inputs)
	if (locale === "fr") return fr_sip_lumpsum_meta_description(inputs)
	if (locale === "it") return it_sip_lumpsum_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_meta_description(inputs)
	if (locale === "pt") return pt_sip_lumpsum_meta_description(inputs)
	if (locale === "ja") return ja_sip_lumpsum_meta_description(inputs)
	return zh_sip_lumpsum_meta_description(inputs)
};